import React from "react";
import _, { get } from "lodash";
import { Div, Text } from "atomize";
import { graphql } from "gatsby";

import Layout from "../components/common/layout";
import Header from "../components/common/Header";
import ResourcesFeatured from "../components/resources/ResourcesFeatured";
import WebsiteContainer from "../components/common/WebsiteContainer";
import CustomContainer from "../components/common/CustomContainer";
import CardsListTwo from "../components/common/CardsListTwo";
import ResourcesGuide from "../components/resources/ResourcesGuide";
import Footer from "../components/common/Footer";

const Blog = ({ data }) => {
  const page = data.page;

  var storyChiefBlogs = data.stories.edges.filter(blog => {
    return blog.node.categories.data.find(name => {
      return name.name === "Blog";
    });
  });

  var contentfulBlogs = data.blogs.edges.filter(blog => {
    return blog.node.label === "Blog";
  });

  var blogs = contentfulBlogs.concat(storyChiefBlogs);

  const featuredStory = data.stories.edges.find(edge => {
    return (
      edge.node.custom_fields.data.findIndex(
        field => field.name === "featuredPost" && field.value == "1"
      ) > -1
    );
  });

  const featuredBlog =
    _.get(featuredStory, "node") || _.get(data.featuredBlogs, "edges.0.node");

  blogs = _.sortBy(blogs, [
    function(blog) {
      if (blog.node.__typename === "StoryChief") {
        return -new Date(blog.node.published_at);
      }

      return -new Date(blog.node.publishedAt);
    },
  ]);
  //   console.log(blogs);

  return (
    <>
      <Layout>
        <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
        <Div m={{ t: "2rem" }}>
          <ResourcesFeatured
            featuredBlog={featuredBlog}
            isStory={featuredBlog.__typename === "StoryChief"}
          />

          <WebsiteContainer>
            <CustomContainer>
              <Div m={{ t: "3.5rem" }}>
                <CardsListTwo category="blog" data={blogs.slice(0, 6)} />
              </Div>
            </CustomContainer>
            <Div m={{ t: "6.8rem" }}>
              <ResourcesGuide
                page={page}
                form={
                  data.contentfulGlobalConfig.resourcesPageForm1
                    .resourcesPageForm1
                }
              />
            </Div>
            <CustomContainer>
              <Div m={{ t: "3.5rem" }}>
                <CardsListTwo
                  category="blog"
                  data={blogs.slice(6, blogs.length)}
                />
              </Div>
            </CustomContainer>
          </WebsiteContainer>
        </Div>
        <Footer
          contentfulFooter={data.contentfulFooter}
          contentfulGlobalConfig={data.contentfulGlobalConfig}
        />
      </Layout>
    </>
  );
};

export const query = graphql`
  query BlogPageQuery {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    page: contentfulResourcePage {
      sendMeGuideTitle
      sendMeGuideImage {
        file {
          url
        }
        description
      }

      seo {
        ...SeoFragment
      }
    }

    contentfulGlobalConfig {
      resourcesPageForm1 {
        resourcesPageForm1
      }
    }

    blogs: allContentfulBlog(
      sort: { fields: [publishedAt], order: DESC }
      filter: { nonResourcePage: { ne: true } }
    ) {
      edges {
        node {
          __typename
          id
          title
          publishedAt
          thumbnail {
            id
            file {
              url
            }
            description
          }
          slug
          label
        }
      }
    }

    stories: allStoryChief(sort: { fields: [published_at], order: DESC }) {
      edges {
        node {
          __typename
          id
          title
          published_at
          featured_image {
            data {
              name
              url
            }
          }
          excerpt
          categories {
            data {
              name
            }
          }
          custom_fields {
            data {
              key
              name
              value
            }
          }
          slug
        }
      }
    }

    featuredBlogs: allContentfulBlog(
      limit: 1
      sort: { fields: [publishedAt], order: DESC }
      filter: { featured: { eq: true }, nonResourcePage: { ne: true } }
    ) {
      edges {
        node {
          id
          title
          publishedAt
          thumbnail {
            id
            file {
              url
            }
            description
          }
          slug
          label
          description
        }
      }
    }
  }
`;

export default Blog;
